import { UserGroupsApiFactory } from '@eloomi/eloomi-user-groups-persona-client/1.0';

import { authorizeClient } from '@/api/authorize-client';

const userGroupsApiClient = authorizeClient(UserGroupsApiFactory);
export function assignUser(payload: { group_id: number; user_ids: number[] }) {
    return userGroupsApiClient.assignUsersToUserGroup(payload);
}
